import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../store/authenticationStore'
import utils from '../utils'

export const BookRequest = {
  //Book Group
  getBookGroup: type =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/book-groups`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      ...(!utils.isNullish(type) && { params: { type: type } }),
    }),

  //Book
  getBookByBookGroupId: bookGroupId =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/book-groups/${bookGroupId}/books`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
}
